import React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import CachedResponse from '../common/CachedResponse';
import NotFound from '../NotFound';
import BrowseInventoryV2 from './BrowseInventoryV2';
import CreateInventory from './CreateInventory';
import InventoryDetails from './InventoryDetails';
import SiteMap from './SiteMap';
import useRefetchChoices from '../../hooks/useRefetchChoices';
import {
  ROLE_ADMIN,
  ROLE_INVENTORY_MANAGER,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SERVICE,
  ROLE_SUPER_ADMIN
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';

const Inventory = () => {
  const { triggerRefetch, refetchChoices, handleRefetchComplete } = useRefetchChoices();
  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/inventory/create">
          <CachedResponse
            listEndpoint={'app-choices'}
            triggerRefetch={triggerRefetch}
            onRefetchComplete={handleRefetchComplete}
            render={appChoices => <CreateInventory appChoices={appChoices} refetchChoices={refetchChoices} />}
          />
        </Route>
        <Route exact path="/inventory/browse">
          <CachedResponse
            listEndpoint={'app-choices'}
            triggerRefetch={triggerRefetch}
            onRefetchComplete={handleRefetchComplete}
            render={appChoices => <BrowseInventoryV2 preset="browse" appChoices={appChoices} refetchChoices={refetchChoices} />}
          />
        </Route>
        <Route exact path="/inventory/site-map">
          <SiteMap />
        </Route>
        <Route exact path="/inventory/:id">
          <CachedResponse
            listEndpoint={'app-choices'}
            triggerRefetch={triggerRefetch}
            onRefetchComplete={handleRefetchComplete}
            render={appChoices => <InventoryDetails appChoices={appChoices} refetchChoices={refetchChoices} />}
          />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  if (
    !userHasAnyRole(
      ROLE_SALES_MANAGER,
      ROLE_SALES,
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_SERVICE,
      ROLE_INVENTORY_MANAGER,
      ROLE_SALES_AND_INVENTORY_MANAGER
    )
  ) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return getActivePage();
};

export default withRouter(Inventory);
